var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPositivo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7714",
    "data-name": "Grupo 7714",
    transform: "translate(0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6579",
    "data-name": "Grupo 6579"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_191",
    "data-name": "Elipse 191",
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    transform: "translate(-0.001 0.001)",
    fill: "#9eaced"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6368",
    "data-name": "Trazado 6368",
    d: "M210.746,210.85a2.982,2.982,0,0,1,4.2,0l6.857,6.858,17.263-17.263a2.982,2.982,0,0,1,4.2,4.2l-19.38,19.38h0a2.982,2.982,0,0,1-4.2,0l-8.945-8.945a2.981,2.981,0,0,1,0-4.234Z",
    transform: "translate(-196.021 -180.357)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPositivo);
export default __webpack_public_path__ + "static/media/ICO-POSITIVO.9f38416c6ee50f14747f3a80e2af7e46.svg";
export { ForwardRef as ReactComponent };